<template>
  <PopupModal :show="show" @close-popup="closeModal">
    <div
      class="bg-white w-[327px] lg:w-[400px] text-center rounded-2xl m-auto fixed inset-0 h-fit shadow-[0_1px_25px_rgba(0,0,0,0.25)] z-50 mx-auto px-6 pt-8 pb-6"
      @click.stop
    >
      <div class="font-aktiv-grotesk-medium text-[24px] leading-[32px] text-[#21252C] mb-3">
        View Past GIC Photos
      </div>
      <p class="text-grey-100 font-aktiv-grotesk-regular text-[16px] leading-[24px] mb-6">
        Relive the memories! Select the previous GIC sessions that you would like to view:
      </p>
      <div class="flex flex-col gap-3">
        <button
          class="flex items-center justify-between rounded-full w-full border-2 border-solid border-orange text-orange font-aktiv-grotesk-medium text-[16px] leading-[24px] px-5 py-3"
          data-test-id="gensapp-photodrop-past-gics-gic2"
          data-event-tracking="gensapp-photodrop-past-gics-gic2"
          @click="openGic2"
        >
          GIC 2
          <ChevronRightIcon />
        </button>
        <button
          class="flex items-center justify-between rounded-full w-full border-2 border-solid border-orange text-orange font-aktiv-grotesk-medium text-[16px] leading-[24px] px-5 py-3"
          data-test-id="gensapp-photodrop-past-gics-gic3"
          data-event-tracking="gensapp-photodrop-past-gics-gic3"
          @click="openGic3"
        >
          GIC 3
          <ChevronRightIcon />
        </button>
      </div>
    </div>
  </PopupModal>
</template>

<script>
import { mapState } from 'vuex';
import { Browser } from '@capacitor/browser';
import PopupModal from '@/components/common/PopupModal.vue';

const ChevronRightIcon = {
  template: `<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M7.5 15L12.5 10L7.5 5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
  </svg>`,
};

export default {
  name: 'PastGicsModal',
  components: {
    PopupModal,
    ChevronRightIcon,
  },
  props: {
    show: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['close-modal'],
  computed: {
    ...mapState('cms', ['gicPixiesetUrl']),
  },
  methods: {
    closeModal() {
      this.$emit('close-modal');
    },
    async openGic2() {
      this.closeModal();
      await Browser.open({ url: this.gicPixiesetUrl });
    },
    openGic3() {
      this.closeModal();
      this.$router.push('/gic/photodrop-gic3');
    },
  },
};
</script>

<style scoped></style>
